/**
 * Waits for x ms before returning.
 *
 * Named pause so it is not confused with await (ie. await wait(500));
 * @param ms the ms to wait defaults to 250
 */
export async function pause(ms: number = 250): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => resolve(), ms);
  });
}
